module.exports = __webpack_public_path__ + "a7a3f32f3473d12f9f615fc6c67653ab.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/geo-webfont/geo-thin.ttf
// module id = 93
// module chunks = 0